/* eslint-disable react/forbid-elements */
import * as React from 'react';

export const BigHeartIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="54" viewBox="0 0 60 54">
    <defs>
      <path
        id="icon-heart-big-path"
        d="M149.96 93.127C127.172 73.992 121 67.256 121 56.314 121 47.32 128.099 40 136.824 40c7.292 0 11.413 4.27 14.176 7.481C153.763 44.27 157.884 40 165.176 40 173.901 40 181 47.319 181 56.314c0 10.942-6.172 17.678-28.96 36.813l-.273.23a1.233 1.233 0 0 1-1.534 0l-.273-.23z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(-121 -40)">
      <use fill="#FF9D00" xlinkHref="#icon-heart-big-path" />
      <path
        stroke="#E68E00"
        strokeWidth="6"
        d="M151 90.082c-22.46-18.908-27-24.653-27-33.768C124 48.955 129.776 43 136.824 43c4.963 0 8.094 2.01 11.902 6.438L151 52.082l2.274-2.644c3.808-4.427 6.94-6.438 11.902-6.438C172.224 43 178 48.955 178 56.314c0 9.115-4.54 14.86-27 33.768z"
      />
    </g>
  </svg>
);
